import React, { useState, useMemo } from 'react';

import { Icon, IconArrowUp, IconArrowDown } from '@flixbus/honeycomb-icons-react';
import { Button, Dropdown, DropdownItem } from '@flixbus/honeycomb-react';

import { useActiveElements } from 'global/ActiveElements/useActiveElements';

import { buildActionItems } from './actionsConfig';
import { NEW_ACTIONS_TEXT } from './text';

import styles from './styles.module.css';

/**
 * PROPS:
 * - actions?: Array<string> (list of modal names to show, in desired order)
 *           Defaults to the standard set below.
 * - payloads?: Record<string, any> (per-action payloads passed to setActiveElement)
 *           e.g. { [MODAL_NAMES.absence]: { readOnly:false } }
 */
const NewActions = ({ actions, payloads = {} }) => {
	const [open, setOpen] = useState(false);
	const active = useActiveElements();

	const items = useMemo(
		() => buildActionItems({ allow: actions ?? undefined, payloads }),
		[actions, payloads]
	);

	const handleSelect = (e, name, payload) => {
		e.preventDefault();
		active.setActiveElement(name, payload);
		setOpen(false);
	};

	const links = items.map(({ name, label, payload }) => (
		<DropdownItem Elem="a" href="/" onClick={(e) => handleSelect(e, name, payload)} key={name}>
			{label}
		</DropdownItem>
	));

	return (
		<div className={styles.container}>
			<Dropdown active={open} links={links} onToggle={setOpen} yPosition="bottom" xPosition="left">
				<Button>
					{NEW_ACTIONS_TEXT.triggerLabel}
					<Icon InlineIcon={open ? IconArrowUp : IconArrowDown} />
				</Button>
			</Dropdown>
		</div>
	);
};

export default NewActions;
